export enum PropertyBoxType {
    RECOMMENDED = "recommended",
    MAIN = "main"
}
export enum PropertyBoxType {
    RECOMMENDED = "recommended",
    MAIN = "main"
}
